import { createFormContext } from '@mantine/form'

export const [UserGeneralFormProvider, useUserGeneralFormContext, useUserGeneralForm] = createFormContext()